import { FormLabel } from '@chakra-ui/react';
import { useRef } from 'react';

import {
  CmBox,
  CmButton,
  CmFlex,
  CmFormControl,
  CmHelpterText,
  CmInput,
  CmText,
} from '@/components/uiParts';
import { SvgAddPhotoAlternate } from '@/pages/camel-kiosk/stores/details/components/AddPhotoAlternate';
import { ColorSetting } from '@/pages/camel-kiosk/stores/details/components/ColorSetting';

import { IMAGE_TYPES, useStoreSettingForm } from './useStoreSettingForm';

type Props = {
  accountId: string;
};

const StoreSettingForm: React.FC<Props> = (props) => {
  const {
    imageSrc,
    handleChangeImage,
    handleSubmit,
    isLoading,
    isSubmitFailed,
    primaryColor,
    handleChangeColor,
    privacyPolicyUrl,
    handleChangePrivacyPolicyUrl,
  } = useStoreSettingForm({
    accountId: props.accountId,
  });

  const imageInputRef = useRef<HTMLInputElement>(null);
  const handleClickImageChange = () => {
    imageInputRef.current?.click();
  };

  return (
    <form style={{ position: 'relative' }} onSubmit={handleSubmit}>
      <CmButton
        type="submit"
        color="white"
        backgroundColor="#F5A128"
        borderRadius="full"
        position="absolute"
        top="24px"
        right="24px"
        zIndex={10}
        disabled={isLoading || isSubmitFailed}
      >
        保存
      </CmButton>
      <CmFlex direction="column" gridGap={6}>
        <CmFormControl>
          <ColorSetting
            color={primaryColor}
            onChangeColorHandler={handleChangeColor}
          />
        </CmFormControl>
        <CmFormControl width="400px">
          <CmFlex align="center" mb={1}>
            <FormLabel fontSize="md" fontWeight="medium" m={0}>
              TOP画像設定
            </FormLabel>
            <CmBox
              bg="red.50"
              px={2}
              py={0.5}
              borderRadius="md"
              fontSize="xs"
              color="red.500"
              fontWeight="medium"
              ml={2}
            >
              必須
            </CmBox>
          </CmFlex>
          <CmFlex marginTop="12px" direction="column">
            <CmHelpterText>
              ファイルの要件：
              {IMAGE_TYPES.map((e) => e.split('/')[1]).join('、')} (最大5MB)
            </CmHelpterText>
            {imageSrc !== '' ? (
              <img
                alt=""
                src={imageSrc}
                style={{ width: 400, height: 200, objectFit: 'cover' }}
              />
            ) : (
              <CmBox marginTop="12px" width="400px" height="200px" bg="#F7F7F7">
                <CmFlex
                  justifyContent="center"
                  alignItems="center"
                  width="100%"
                  height="100%"
                >
                  <SvgAddPhotoAlternate />
                </CmFlex>
              </CmBox>
            )}

            <CmButton
              marginTop="12px"
              borderRadius="full"
              color="#F5A128"
              variant="outline"
              onClick={handleClickImageChange}
            >
              画像を選択
            </CmButton>
            <CmInput
              ref={imageInputRef}
              type="file"
              accept={IMAGE_TYPES.join(',')}
              style={{ visibility: 'hidden' }}
              onChange={handleChangeImage}
            />
          </CmFlex>
        </CmFormControl>
        <CmFormControl>
          <CmBox>
            <CmText mb={2} fontSize="sm">
              プライバシーポリシーURL
            </CmText>
            <CmInput
              placeholder="https://example.com/privacy-policy"
              value={privacyPolicyUrl}
              onChange={handleChangePrivacyPolicyUrl}
              width="100%"
              maxW="600px"
            />
          </CmBox>
        </CmFormControl>
      </CmFlex>
    </form>
  );
};

export default StoreSettingForm;
